export class UpdateWorkspaceMetricsSettingsInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsMetricsSettingsInput",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpMetricsSettingsInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceMetricsSettingsInput.attributeTypeMap;
    }
    constructor() {
    }
}
